<h2 mat-dialog-title class="text-xl font-bold text-primary mb-4">
  Assistance Fee Agreement
</h2>

<div mat-dialog-content class="text-text-secondary">
  <p class="mb-4">
    This accommodation was posted by an outgoing corp member to help facilitate a smooth handover of the property.
  </p>
  
  <p class="mb-4">
    If you proceed to inspect the accommodation, agree to the landlord's terms, and decide to rent it, you agree to pay an assistance fee of <strong>₦10,000</strong> to the outgoing corp member.
  </p>
  
  <p class="mb-4">
    If you decide not to take the accommodation, no payment is required. By continuing, you agree to the assistance fee agreement.
  </p>
  
  <div class="mb-4 space-y-2">
    <a 
      href="/about#disclaimer"
      target="_blank"
      class="text-primary hover:underline text-sm inline-flex items-center w-fit"
    >
      Learn why this agreement is in place <mat-icon inline>arrow_outward</mat-icon>
    </a>
  </div>
  
  <div class="bg-background-light border border-gray-300 rounded p-3 mb-4">
    <p class="text-sm text-text-secondary">
      <strong>Transact safely.</strong> Read our 
      <a href="/about#disclaimer" target="_blank" class="text-primary hover:underline inline-flex items-center w-fit">User Guide and Safety Manual <mat-icon inline>arrow_outward</mat-icon></a> 
      to protect yourself from fraudsters.
    </p>
  </div>
</div>

<mat-dialog-actions align="end" class="mt-4">
  <button 
    type="button" 
    mat-button 
    mat-dialog-close
    class="text-primary"
  >
    I understand
  </button>
</mat-dialog-actions>
